import { localizedStrings } from '@core/strings'
import React, { useMemo } from 'react'
import { Box } from 'webapp/components/common/fundamentals'
import { Card, Divider } from '@common/material'
import { CardContent, Typography } from '@mui/material'
import {
  RegisterItem,
  RegisterItemFlatPropertyData,
  RegisterItemInspectionProperty,
} from '@core/entities/register/RegisterItem'
import { RegisterItemInspectionCard } from './RegisterItemInspectionCard'
import { RegisterItemDetailsProperties } from './RegisterItemDetailsProperties'

type RegisterItemDetailsSidebarProps = {
  registerItem: RegisterItem
}

export const RegisterItemDetailsSidebar: React.FC<
  RegisterItemDetailsSidebarProps
> = ({ registerItem }) => {
  const memoisedUniqueInspectionColumns: RegisterItemFlatPropertyData[] =
    useMemo(() => {
      return registerItem.data?.filter((column) => column.type === 'INSPECTION')
    }, [registerItem.data])

  return (
    <Box>
      <Card>
        <CardContent>
          <Typography
            sx={{ fontSize: '16px' }}
            variant='h6'
            color='text.primary'
            gutterBottom
          >
            {localizedStrings.properties}
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <RegisterItemDetailsProperties
            registerItem={registerItem}
            excludedProperties={['INSPECTION', 'PERMIT']}
          />
        </CardContent>
      </Card>

      {registerItem.hasInspection() && (
        <Card sx={{ mt: 2 }} data-test='inspection-section'>
          <CardContent>
            <Typography
              sx={{ fontSize: '16px' }}
              variant='h6'
              color='text.primary'
              gutterBottom
            >
              {localizedStrings.inspections}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {memoisedUniqueInspectionColumns?.map(
              (item: RegisterItemFlatPropertyData & { value: string }) => {
                return (
                  <RegisterItemInspectionCard
                    key={item.registerPropertyId}
                    registerItem={
                      item as RegisterItemInspectionProperty<string>
                    }
                  />
                )
              },
            )}
          </CardContent>
        </Card>
      )}
    </Box>
  )
}
